import { Component, OnInit } from '@angular/core';
import { CarregandoService } from '../services/carregando.service';
import { PremissasService } from '../services/premissas.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PremissasSistema } from '../models/premissas-sistema';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RZKService } from '../services/rzk.service';

@Component({
  selector: 'app-rzk',
  templateUrl: './rzk.component.html',
  styleUrls: ['./rzk.component.scss']
})
export class RZKComponent implements OnInit {

  premissasSistema: PremissasSistema;
  linkDeAcesso;
  idIntegrador;

  constructor(private carregandoService: CarregandoService, private premissasService: PremissasService, private notificacaoService: NotificacaoService,
    private router: Router, private globalService: GlobalService, private sanitizer: DomSanitizer, private rzkService: RZKService, private route: ActivatedRoute
  ) { }

  async ngOnInit() {

    await this.buscarPremissasSistema();

    const integrador = await this.globalService.integrador();
    const usuarioLogado = await this.globalService.consultaUsuario();

    if (this.route.snapshot.paramMap.get('id')) {
      this.idIntegrador = Number(this.route.snapshot.paramMap.get('id'));

      if (!this.premissasSistema.integracaoRZK || integrador || !(await this.possuiRzkId())) {
        this.router.navigate(['/']);
      } else {
        await this.buscarLinkDeAcesso();
      }
    } else {
      this.idIntegrador = usuarioLogado.id;
      if (!this.premissasSistema.integracaoRZK || !integrador || !(await this.possuiRzkId())) {
        this.router.navigate(['/']);
      } else {
        await this.buscarLinkDeAcesso();
      }
    }


  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async buscarLinkDeAcesso() {
    try {
      this.carregandoService.mostra('buscarLinkDeAcesso');
      this.linkDeAcesso = this.sanitizer.bypassSecurityTrustResourceUrl((await this.rzkService.buscarLinkDeAcesso(this.idIntegrador).toPromise()).link);
    } catch (erro) {
      this.notificacaoService.erro(erro);
      console.log('erro:', erro);
    } finally {
      this.carregandoService.esconde('buscarLinkDeAcesso');
    }
  }

  async possuiRzkId() {
    try {
      this.carregandoService.mostra('possuiRzkId');
      return (await this.rzkService.possuiRzkId(this.idIntegrador).toPromise()).valor;
    } catch (erro) {
      this.notificacaoService.erro(erro);
      console.log('erro:', erro);
    } finally {
      this.carregandoService.esconde('possuiRzkId');
    }
  }

}
